/** Returns a plain-English problem with the new password, or null when it is fine. */
export function checkPassword(password: string, confirm: string): string | null {
  if (!password) return "Type a new password.";
  if (password.length < 8) return "Use at least 8 characters.";
  if (password !== confirm) return "The two passwords don't match.";
  return null;
}
